<template>
  <div>
    <Navbar />

    <div class="wrapper d-flex justify-content-center">
      <div class="card py-5 shadow">
        <div class="card-body text-center">
          <p class="font-weight-bold m-1">
            {{ $t('permission.error-text-one') }}
          </p>
          <p class="font-italic">
            <small>
              {{ $t('permission.error-text-two') }}
            </small>
          </p>

          <button
            class="btn btn-info mt-5"
            @click="backToLogin"
          >
            <small class="font-weight-bold">
              {{ $t('permission.back') }}
            </small>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Navbar from '@/components/Navbar'

export default {
  components: {
    Navbar
  },

  methods: {
    backToLogin () {
      localStorage.clear()
      this.$router.push({
        path: '/'
      })
    }
  }
}
</script>

<style scoped>
.wrapper {
  align-items: center;
  background-color: #f5efff;
  background-image: url("~@/assets/image/bg-2.png");
  background-position: bottom;
  background-repeat: no-repeat;
  display: flex;
  min-height: 100vh;
}

</style>
